import(/* webpackMode: "eager" */ "/app/src/app/accommodation/[cityName]/error.tsx");
